const ALL = 'ALL';

let k_assetGrid, k_searchIndicator;

let previousFreeTextSearch;

let deviceTypeFilters = {};
let deviceStatusFilters = [];

let previousFreeTextDevices = [];
let foundDevices = [];

export const setUpGridFilters = () => {
    k_assetGrid = $('.js-tech-asset-grid').data('kendoGrid');
    if (!k_assetGrid) return;
    
    addFilterEvents();
    setupFreeTextFilter();
    setUpDeviceTypeFilter();
    setUpDeviceStatusFilter();
};

const filter = () => {
    kendo.ui.progress(k_assetGrid.element, true);
    setTimeout(() => {
        const ftSearchField = $('.js-search-box.k-input').data('kendoTextBox');
        const ftSearchTerm = ftSearchField.value().trim();
        const employeeData = k_assetGrid.dataSource.data();
        foundDevices = [];
        if(ftSearchTerm === previousFreeTextSearch) previousFreeTextDevices = [];
        employeeData.forEach(di => {
            const devicesFound = findDevices(di.Devices, ftSearchTerm);
            previousFreeTextSearch = ftSearchTerm;
            di.HasVisibleDevice = devicesFound.length > 0;
            foundDevices.push(...devicesFound);
        });
        k_assetGrid.dataSource.filter({field: 'HasVisibleDevice', value: true});
        kendo.ui.progress(k_assetGrid.element, false);
        expandRows();
        refreshListView();
        updateFoundDeviceText();
    }, 100);
};

const addFilterEvents = () => {
    const $devicesFilter = $('input.k-input[aria-label="Devices"][data-role="numerictextbox"]');
    const k_devicesFilter = $devicesFilter.data('kendoNumericTextBox');
    
    let filterTimeout;
    
    $devicesFilter.bind('keyup', function (e) {
        clearTimeout(filterTimeout);
        filterTimeout = setTimeout(function () {
            $devicesFilter.trigger('focusout');
        }, 500);
    });
    
    k_devicesFilter.bind('spin', function (e) {
        clearTimeout(filterTimeout);
        filterTimeout = setTimeout(function () {
            $devicesFilter.trigger('focusout');
        }, 500);
    });
}

const keysToIgnore = ['_events', '_handlers', 'change', 'ImageName', 'KaceId', 'KaceGuid', 'UserLogged', 'Id', 'IsAssigned', 
                      'IsAvailable', 'IsDecommissioned', 'IsLostOrStolen', 'IsReleased', 'uid', 'parent'];
const findDevices = (deviceList, searchValue, previousValue) => {
    const devices = [];
    const searchExpression = new RegExp(searchValue.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
    deviceList.forEach(di => {
        const dtf = deviceTypeFilters;
        const typeMatch = dtf.hasOwnProperty('field') ? di[dtf.field] === dtf.value : true;
        const statusMatch = deviceStatusFilters.length ? deviceStatusFilters.some(dsf => di[dsf.field] === dsf.value) : true;
        
        const searchDevices = searchValue.length && searchValue !== '' && searchValue !== previousValue;
        let freeTextMatch = !searchDevices;
        if (searchDevices) {
            const keys = Object.keys(di)
                               .filter(key => !keysToIgnore.includes(key));
            for (let i = 0; (i < keys.length && !freeTextMatch); i++) {
                const key = keys[i];
                const value = di[key];
                if(!value) continue;
                const valueAsDate = new Date(Date.parse(value.toString()));
                if(key === 'HistoryRecords') {
                    for (let hxi = 0; (hxi < value.length && !freeTextMatch); hxi++) {
                        const record = value[hxi];
                        if(!record) continue;
                        const recordKeys = Object.keys(record)
                                                 .filter(key => !keysToIgnore.includes(key));
                        for (let rki = 0; (rki < recordKeys.length && !freeTextMatch); rki++) {
                            const recordKey = recordKeys[rki];
                            const value = record[recordKey] ?? '';
                            const valueAsDate = new Date(Date.parse(value.toString()));
                            if (searchExpression.test(value.toString()) || searchExpression.test(valueAsDate.toLocaleString())) {
                                freeTextMatch = true;
                                previousFreeTextDevices.push(di);
                                break;
                            }
                        }
                    }
                } else if(key === 'CostCenters') {
                    for (const ccValue of value) {
                        if(searchExpression.test(ccValue.toString()) || searchExpression.test(ccValue.toLocaleString())) {
                            freeTextMatch = true;
                            previousFreeTextDevices.push(di);
                            break;
                        }
                    }
                } else if (searchExpression.test(value.toString()) || searchExpression.test(valueAsDate.toLocaleString())) {
                    freeTextMatch = true;
                    previousFreeTextDevices.push(di);
                    break;
                }
            }
        } else if(searchValue === previousValue) {
            freeTextMatch = previousFreeTextDevices.contains(di);
        }
        const visible = statusMatch && freeTextMatch && typeMatch;
        di.Visible = visible;
        if(visible) {
            devices.push(di);
        }
    });
    return devices;
};

const setupFreeTextFilter = () => {
    //Setup Search TextBox
    const $searchDevices = $('.js-search-container .js-search-box').kendoTextBox({
        placeholder: 'Search for devices...'
    });
    
    //Setup Delay auto search
    let timeout;
    $searchDevices.bind('keyup', function (e) {
        //Get value
        let value = $(e.currentTarget).val();
        //Set value to kendo TextBox
        $('.js-search-box.k-input').data('kendoTextBox').value(value);
        // Clear old timeout
        clearTimeout(timeout);
        //Create new timeout
        timeout = setTimeout(function () {
            //After wait period, search devices
            filter();
        }, 1000);
    });
    
    //Setup Search Button
    $('.js-search-container .js-search').kendoButton({
        themeColor: 'primary',
        icon: 'search',
        click: filter
    });
};

const setUpDeviceTypeFilter = () => {
    const $deviceTypeSelect = $('.js-device-type-select');
    const k_deviceTypeSelect = $deviceTypeSelect.kendoDropDownList({
        optionLabel: 'Select device type...',
        dataSource: {
            data: [{
                    text: 'Computer',
                    value: 'Computer'
                }, {
                    text: 'Phone',
                    value: 'Phone'
                }, {
                    text: 'Tablet',
                    value: 'Tablet'
                }]
        },
        dataTextField: 'text',
        dataValueField: 'value',
        valuePrimitive: true
    }).data('kendoDropDownList');

    $deviceTypeSelect.bind('change', (e) => {
        const typeToSearch = k_deviceTypeSelect.value();
        if (typeToSearch === '') deviceTypeFilters = {};
        else deviceTypeFilters = {field: 'Type', value: typeToSearch};
        filter();
    });
};

const setUpDeviceStatusFilter = () => {
    const $deviceStatusMultiSelect = $('.js-device-status-multiselect');
    const k_deviceStatusMultiSelect = $deviceStatusMultiSelect.kendoMultiSelect({
        placeholder: 'Select device status...',
        dataTextField: 'text',
        dataValueField: 'value',
        autoBind: true,
        dataSource: {
            data: [{
                    text: 'Unknown',
                    value: {field: 'IsUnknown', value: true}
                }, {
                    text: 'Unassigned',
                    value: {field: 'IsUnassigned', value: true}
                },
                {
                    text: 'Assigned',
                    value: {field: 'IsAssigned', value: true}
                }, {
                    text: 'Available',
                    value: {field: 'IsAvailable', value: true}
                }, {
                    text: 'Lost/Stolen',
                    value: {field: 'IsLostOrStolen', value: true}
                }, {
                    text: 'Decommissioned',
                    value: {field: 'IsDecommissioned', value: true}
                }, {
                    text: 'Released',
                    value: {field: 'IsReleased', value: true}
                }]
        }
    }).data('kendoMultiSelect');
    
    k_assetGrid.dataSource.one('dataBound', () => {
        k_deviceStatusMultiSelect.value({field: 'IsAvailable', value: true});
        k_deviceStatusMultiSelect.trigger('change');
    });

    $deviceStatusMultiSelect.bind('change', (e) => {
        $('input.k-input.k-readonly').attr('style', '');
        deviceStatusFilters = k_deviceStatusMultiSelect.value();
        filter();
    });

    $('input.k-input.k-readonly').attr('style', '');
};

const refreshListView = () => {
    const $listViews = $('.k-listview');
    if ($listViews.length === 0) return;
    $.each($listViews, (index, element) => {
        const k_listView = $(element).data('kendoListView');
        if (k_listView) {
            k_listView.dataSource.filter({field: 'Visible', value: true});
        }
    });
};

const expandRows = () => {
    $('.k-master-row').slice(0, 10).each((i, row) => k_assetGrid.expandRow(row));
};

const updateFoundDeviceText = () => {
    if (foundDevices.length === 1) {
        const singleDevice = foundDevices[0] ?? {};
        $('.js-search-found').text(`1 device found`);
        $(`div.device.found[data-type="${singleDevice.Type}"][data-device-id="${singleDevice.Id}"]`).trigger('click');
    } else {
        $('.js-search-found').text(`${foundDevices.length} devices found`);
    }
};